"use strict";
exports.__esModule = true;
exports.COLORS = exports.ROUNDED = exports.TYPE = void 0;
exports.TYPE = {
    legend: 'border rounded p-5',
    normal: 'px-4'
};
exports.ROUNDED = {
    full: 'rounded-full',
    huge: 'rounded-3xl',
    large: 'rounded-2xl',
    medium: 'rounded-lg',
    small: 'rounded',
    tiny: 'rounded-sm',
    none: 'rounded-none'
};
exports.COLORS = {
    primary: 'border-primary',
    secondary: 'border-secondary',
    tertiary: 'border-tertiary',
    info: 'border-info',
    danger: 'border-danger',
    warning: 'border-warning',
    success: 'border-success',
    control: 'border-control',
    black: 'border-black',
    inherit: 'hover:bg-transparent',
    slate: 'border-slate-500',
    zinc: 'border-zinc-500',
    neutral: 'border-neutral-500',
    stone: 'border-stone-500',
    red: 'border-red-500',
    orange: 'border-orange-500',
    amber: 'border-amber-500',
    yellow: 'border-yellow-500',
    lime: 'border-lime-500',
    green: 'border-green-500',
    emerald: 'border-emerald-500',
    teal: 'border-teal-500',
    cyan: 'border-cyan-500',
    sky: 'border-sky-500',
    blue: 'border-blue-500',
    indigo: 'border-indigo-500',
    violet: 'border-violet-500',
    purple: 'border-purple-500',
    fuchsia: 'border-fuchsia-500',
    pink: 'border-pink-500',
    rose: 'border-rose-500'
};
//# sourceMappingURL=form-control-style.js.map